var _defs, _g;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUploadingFolder = function SvgUploadingFolder(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56.906,
    height: 50.267,
    viewBox: "0 0 56.906 50.267",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:#d6ebee;}.c{fill:rgba(45,149,167,0.19);}.d{fill:#415cd6;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M31.3,38.4H10.448a1.915,1.915,0,0,0-1.915,1.915V54.523H33.192l.018-8.536V40.315A1.915,1.915,0,0,0,31.3,38.4Z",
    transform: "translate(-7.585 -37.451)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M116.5,45.988V40.315a1.915,1.915,0,0,0-1.915-1.915H104.152a1.915,1.915,0,0,0-1.915,1.915V54.523h44.594V47.9a1.915,1.915,0,0,0-1.915-1.915H116.5Z",
    transform: "translate(-90.874 -37.451)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.794 0.949)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M55.965,45.988V40.315A1.915,1.915,0,0,0,54.05,38.4h-18a1.915,1.915,0,0,0-1.915,1.915V54.523H83.452V47.9a1.915,1.915,0,0,0-1.915-1.915H55.965Z",
    transform: "translate(-34.133 -38.4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M281.438,183.467h24.677V213.8a1.915,1.915,0,0,1-1.915,1.915H283.353a1.915,1.915,0,0,1-1.915-1.915Z",
    transform: "translate(-253.951 -167.344)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.533,183.467H33.21V213.8a1.915,1.915,0,0,1-1.915,1.915H10.448A1.915,1.915,0,0,1,8.533,213.8Z",
    transform: "translate(-7.585 -166.395)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M34.133,183.467H83.452V213.8a1.915,1.915,0,0,1-1.915,1.915H36.048a1.915,1.915,0,0,1-1.915-1.915Z",
    transform: "translate(-30.339 -166.395)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M54.042,209.078H2.864A2.867,2.867,0,0,1,0,206.214V175.882a.948.948,0,0,1,.948-.948H55.958a.948.948,0,0,1,.948.948v30.331a2.867,2.867,0,0,1-2.864,2.864ZM1.9,176.831v29.383a.968.968,0,0,0,.967.967H54.042a.968.968,0,0,0,.967-.967V176.831Z",
    transform: "translate(0 -158.81)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M55.958,47.886H.948A.948.948,0,0,1,0,46.938V32.73a2.867,2.867,0,0,1,2.864-2.864H23.711a2.867,2.867,0,0,1,2.864,2.864v4.724H54.042a2.867,2.867,0,0,1,2.864,2.864v6.621a.948.948,0,0,1-.949.948ZM1.9,45.989H55.009V40.317a.968.968,0,0,0-.967-.967H25.626a.948.948,0,0,1-.948-.948V32.73a.968.968,0,0,0-.967-.967H2.864a.968.968,0,0,0-.967.967v13.26Z",
    transform: "translate(0 -29.866)"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUploadingFolder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/uploadingFolder.b4827a7f.svg";
export { ForwardRef as ReactComponent };